import { track } from "@amplitude/analytics-react-native";
import { useMemo } from "react";
import Animated from "react-native-reanimated";
import { amp } from "src/api/amplitude";
import PillButton from "src/components/PillButton";
import ProfilePictureRow from "src/components/ProfilePictureRow";
import abbreviateBigNumber from "src/helpers/abbreviateBigNumber";
import useAnimatedOpacityStyle from "src/hooks/useAnimatedOpacityStyle";
import IconPhoto from "src/icons/IconPhoto";
import { paddingMedium, paddingSmall } from "src/styles/spacing";
import { useGatheringPreviewPublicStore } from "../../../hooks/useGatheringPreviewPublicStore";
import useGatheringPublicPreviewInfo from "../../../hooks/useGatheringPublicPreviewInfo";

const NUM_PREVIEWED_VIEWERS = 3;
const GatheringPreviewPublicTags = () => {
	const gatheringId = useGatheringPreviewPublicStore((state) => state.gatheringId);
	const { gathering, loading } = useGatheringPublicPreviewInfo(gatheringId);
	const setPopUpVariant = useGatheringPreviewPublicStore((state) => state.setPopUpVariant);

	const pillText = useMemo(() => {
		if (loading || gathering?.numParticipants == null) return "See viewers";
		if (gathering.numParticipants === 0) {
			return `See viewers`;
		}
		if (gathering.numParticipants <= NUM_PREVIEWED_VIEWERS) {
			return `See all`;
		}
		return `See ${gathering.numParticipants - NUM_PREVIEWED_VIEWERS} more`;
	}, [gathering?.numParticipants, loading]);

	const animatedStyle = useAnimatedOpacityStyle(
		loading || gathering?.numParticipants == null ? 0 : 1,
	);
	const users = useMemo(
		() => gathering?.previewUsers?.payload ?? [],
		[gathering?.previewUsers?.payload],
	);

	return (
		<>
			<Animated.View style={[animatedStyle]}>
				<PillButton
					testID="GatheringPreviewPublicViewersTag"
					onPress={() => {
						setPopUpVariant("SeeViewers");
						track(amp.gathering.previewSeeViewersPressed, {
							gatheringId: gathering?.gatheringId,
						});
					}}
					CustomIcon={
						<ProfilePictureRow
							users={users}
							size={24}
							containerStyle={{
								marginRight: paddingSmall,
								marginLeft: paddingMedium,
							}}
						/>
					}
					textProps={{
						semibold: true,
					}}
				>
					{pillText}
				</PillButton>
			</Animated.View>
			<Animated.View style={[animatedStyle]}>
				{gathering?.numPhotos != null && (
					<PillButton
						testID="GatheringPreview-NumPhotos"
						key="photos"
						onPress={() => {
							track("gathering_previewPublic_photosCountPress", {
								gatheringId,
							});
							setPopUpVariant("SeePhotos");
						}}
						Icon={IconPhoto}
					>
						{`${abbreviateBigNumber(gathering.numPhotos)}`}
					</PillButton>
				)}
			</Animated.View>
		</>
	);
};
export default GatheringPreviewPublicTags;
